import React, {useState} from 'react';
import {useTranslation} from "react-i18next";
import {toast} from "react-toastify";
import {useDispatch} from "react-redux";

import css from './CancellationOrderModal.module.css';
import {ordersService} from "../../../../services/orders-services";
import {ordersActions} from "../../../../store/slices/orders-slices";


const CancellationOrderModal = ({setIsShowCancellation, order}) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const [isShowMethod, setIsShowMethod] = useState(false);

    const handleCancellationClick = async () => {
        try {
            await ordersService.deleteMoveOrderToAnotherDate(order.id);
            dispatch(ordersActions.changeTrigger());

            setIsShowCancellation(false);
        } catch (error) {
            console.error(t('modal-toast-fetch-error'), error);
            toast.error(t('modal-toast-fetch-error'));
        }
    };

    const changeMethod = () => {
        setIsShowMethod(true);
    };


    const changeCurrentMethod = async (e) => {
        try {
            const fData = {
                paymentMethod: e.target.innerText
            }
            await ordersService.updateOrderById(order.id, fData);

            dispatch(ordersActions.changeTrigger());
            setIsShowMethod(false);
        } catch (error) {
            console.error(t('modal-toast-fetch-error'), error);
            toast.error(t('modal-toast-fetch-error'));
        }
    };


    return (
        <div className={css.wrap}>
            <div className={css.infoBlock}>
                <div className={css.price}>
                    {t('order-changed')}. {order.paymentAmount}
                </div>

                <div className={css.paymentMethod}>
                    <div className={css.currentMethod}>{order.paymentMethod}</div>

                    {
                        !isShowMethod ?
                            (<div className={css.changeMethod} onClick={changeMethod}>
                                Change payment method
                            </div>) :
                            <div className={css.blockNtn}>
                                <button className={css.btnMethod}
                                        onClick={changeCurrentMethod}
                                >
                                    Cash
                                </button>

                                <button className={css.btnMethod}
                                        onClick={changeCurrentMethod}
                                >
                                    Transfer
                                </button>
                            </div>
                    }
                </div>
            </div>

            <div className={css.actionBlock}>
                <button className={css.undoChanges}
                        onClick={handleCancellationClick}
                >
                    {t('undo-changes')}
                </button>
            </div>
        </div>
    );
};

export {CancellationOrderModal};